// extracted by mini-css-extract-plugin
export default {"controls":"Controls_controls__w3u4-","blade":"Controls_blade__D94Fn"};